module.exports = __webpack_public_path__ + "static/media/logo_iso_hotel.504b1d6c.svg";